<template>

  <div class="card-background">
      <div class="columns">

          <TournamentMenu :tournament="tournament" />

      <div class="column is-four-fifths-desktop is-four-fifths-tablet is-full-printer">

        <div v-if="tournament" class="tournament-matches-container">

            <div class="columns">
                <div class="column is-four-fifths-tablet is-four-fifths-desktop">
                    <h2 class="has-text-weight-bold has-text-left is-size-3" style="margin-bottom: 20px;">{{ tournament.name }} - Matches</h2>
                </div>

                <div class="column is-one-fifth-tablet is-one-fifth-desktop is-hidden-print">
                    <b-select v-model="hideCompleted" class="is-pulled-right">
                        <option value="no">All matches</option>
                        <option value="completed">Incomplete matches</option>
                        <option value="skippable">Necessary matches</option>
                    </b-select>
                </div>
            </div>


            <div class="notification is-warning" style="padding-top: 9px; padding-bottom: 7px; vertical-align: middle; margin-top: -29px; margin-bottom: 35px;" v-if="matchesNeedRescheduling">
                You have made a modification to one or more events, and some matches need to be rescheduled. &nbsp; &nbsp; <a class="button is-danger is-small" @click="rescheduleMatches(tournament.events[0].scheduleUpdate)">Update</a>
            </div>


            <Matches :matches="matches" :tournament="tournament" :hideCompleted="hideCompleted" :autoRefresh="true" />


            <div class="has-text-right is-hidden-print" style="margin-top: 35px;">
              <router-link :to="'/tournaments/' + tournament.id + '/scheduler'" class="button is-link is-medium">Schedule matches</router-link>
            </div>
        </div>

        <div v-if="!tournament">
          <b-loading />
        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import TournamentMenu from '../components/TournamentMenu.vue';
  import TournamentDataMixin from '../mixins/TournamentDataMixin.js';
  import Matches from "../components/Matches.vue";

export default {
  mixins: [ TournamentDataMixin ],

  data: () => {
    return {
      hideCompleted: 'no'
    }
  },
  computed: {
    tournaments: function(){ return this.$store.state.tournaments; },
    matches: function(){
        if (!this.tournament) {
            return [];
        }

        let matches = [];
        this.tournament.events.forEach(event => {
            event.draws.forEach(draw => {

                draw.matches.forEach(match => {
                    matches.push(Object.assign({}, match, { event: event }));
                });
            });
        });

        return matches;
    },

      matchesNeedRescheduling: function() {
          if (!this.tournament || !this.tournament.events) {
              return false;
          }

          if (this.tournament.events.length > 0 && this.tournament.events[0].scheduleUpdate) {
              return true;
          }

          return false;
      }
  },

  methods: {
  },

  created: function() {
      let hasActiveMatches = false;
      if (this.tournament && this.tournament.events) {
          hasActiveMatches = this.tournament.events.some(event => {
              return (event.hasActiveMatches ? true : false);
          });
      }

      if (hasActiveMatches) {
          this.hideCompleted = 'completed';
      }
  },

  components: { TournamentMenu, Matches },
  name: 'tournament-matches'
}
</script>



<style>

</style>
